import { useCallback, useState } from 'react';
import { useMediaQuery } from '@material-ui/core';
import type { Theme } from '@material-ui/core';

import { useScheduledOrderDetailQuery } from 'features/order/scheduled/hooks';
import { useScheduledOrderPrint } from 'features/order/scheduled/print';

interface Props {
  orderId: number | null;
  onClose: () => void;
}

export function useScheduledOrderDetailDialog({ orderId, onClose }: Props) {
  const { isLoading, isError, data, refetch } = useScheduledOrderDetailQuery(
    orderId,
  );
  const { printOrder } = useScheduledOrderPrint();
  const [isCancelOpen, setCancelOpen] = useState(false);

  const isOpen = !!orderId;
  const isMdUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));

  const handlePrint = useCallback(() => {
    if (!data) return;
    printOrder();
  }, [data, printOrder]);

  const openCancel = () => setCancelOpen(true);

  const closeCancel = () => setCancelOpen(false);

  const closeAfterCancel = () => {
    setCancelOpen(false);
    onClose();
  };

  return {
    isLoading,
    isError,
    data,
    refetch,
    isOpen,
    isMdUp,
    isCancelOpen,
    handlePrint,
    handleClose: onClose,
    openCancel,
    closeCancel,
    closeAfterCancel,
  };
}
